import { $api } from '@service/RequestService';
import { useMutation } from 'react-query';

export const useLeadTagSave = () =>
  useMutation(async (data: { leadId: number; tagIds: number[] }) => {
    const res = await $api.post('/v1/lead/tag', data);

    return res?.data?.data;
  });
